<template>
  <div>
    <div class="f-h"></div>
    <div class="footer">
      <div class="f-a">
        <router-link to="/" exact >
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-zhuye"></use>
              </svg>
            </span>
          <p>首页</p>
        </router-link>
      </div>
      <div class="f-a">
        <router-link to="/orders">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-dingdan1"></use>
              </svg>
            </span>
          <p>订单</p>
        </router-link>
      </div>
      <div class="f-a">
        <router-link to="/data/index">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-lingshouliushuizhangledger"></use>
              </svg>
            </span>
          <p>码库</p>
        </router-link>
      </div>
      <div class="f-a">
        <router-link to="/users/index">
            <span>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-wode"></use>
              </svg>
            </span>
          <p>我的</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: ''
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/footer.vue